export default __webpack_public_path__ + "static/media/pointplate-right.f143ecd5.png";